export default __webpack_public_path__ + "static/media/store.2c7f34aa.png";